import * as React from "react";
import "./reconciliationModal.scss"
import DateUtils from "../../../../../utils/DateUtils";
import CurrencyHelper from "../../../../../helper/CurrencyHelper";
import Transaction from "../../../../../model/transaction/Transaction";

interface IProps {
	transaction: Transaction;
	showMatchRemainingAmount: boolean
	onMatchRemainingAmountClick: () => void;
}

export const PaymentDetails: React.SFC<IProps> = (props) => {
	return (
		<div className="c-reconciliation-modal_payment-container">
			<div className="c-reconciliation-modal_details-title">Payment</div>
			<div className="c-reconciliation-modal_payment-container_details-container">
				<div>
					<span>Name</span>
					<span>Account #</span>
					<span>Branch code</span>
					<span>Comment</span>
					<span>Time</span>
					<span>Amount</span>
					{props.transaction.fee.map(f => <span>Fee</span>).orNull}
					{props.transaction.netAmount.map(na => <span>Total amount</span>).orNull}
				</div>
				<div className="c-reconciliation-modal_payment-container_details-container_values-container">
					<span>{props.transaction.name}</span>
					<span>{props.transaction.accountNo.getOrElse("")}</span>
					<span>{props.transaction.branchCode.getOrElse("")}</span>
					<span>{props.transaction.comment.getOrElse("")}</span>
					<span>{props.transaction.date.format(DateUtils.INVOICE_TIME_DATE_FORMAT)}</span>
					<span>{CurrencyHelper.toCurrency(props.transaction.amount)}</span>
					{props.transaction.fee.map(f => <span>{`-${CurrencyHelper.toCurrency(f)}`}</span>).orNull}
					{props.transaction.netAmount.map(na => <span>{CurrencyHelper.toCurrency(na)}</span>).orNull}
				</div>
			</div>
			{props.showMatchRemainingAmount && props.transaction.due > 0 &&
			<div className="c-reconciliation-modal_undo-link" onClick={props.onMatchRemainingAmountClick}>
				Match remaining amount
			</div>}
		</div>
	);
};
